(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vss-performance-command-deck"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('vss-command-deck')) {
  customElements.define('vss-command-deck', class extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => this.mount());
    }
    mount() {
      this.track = this.querySelector('.vss-cd__grid');
      this.cards = Array.from(this.querySelectorAll('.vss-cd__card'));
      if (!this.track || this.cards.length < 2 || this.dataset.mobileLayout !== 'carousel') return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.mobile = matchMedia('(max-width: 989px)');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.current = 0;
      this.querySelector('.vss-cd__controls').hidden = false;
      this.indicators = Array.from(this.querySelectorAll('[data-indicator]'));
      this.dataset.carouselReady = 'true';
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-step]');
        if (button && button.getAttribute('aria-disabled') !== 'true') this.go(this.current + Number(button.dataset.step));
      }, options);
      this.track.addEventListener('scroll', () => {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.sync(), 90);
      }, { ...options, passive: true });
      this.track.addEventListener('focusin', event => {
        const card = event.target.closest('.vss-cd__card');
        if (card) this.go(this.cards.indexOf(card), true);
      }, options);
      this.track.addEventListener('keydown', event => {
        if (!this.mobile.matches || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        let next = this.current + (event.key === 'ArrowRight' ? 1 : -1);
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = this.cards.length - 1;
        next = Math.max(0, Math.min(next, this.cards.length - 1));
        this.go(next);
        if (event.target.closest('.vss-cd__card')) this.cards[next].querySelector('a')?.focus({ preventScroll: true });
      }, options);
      document.addEventListener('shopify:block:select', event => {
        if (!this.contains(event.target)) return;
        const card = event.target.closest('.vss-cd__card');
        if (card) this.go(this.cards.indexOf(card), true);
      }, options);
      this.mobile.addEventListener('change', () => this.layout(), options);
      this.observer = new ResizeObserver(() => this.sync());
      this.observer.observe(this.track);
      this.layout();
    }
    layout() {
      if (this.mobile.matches) {
        this.track.tabIndex = 0;
        this.track.setAttribute('role', 'region');
        this.track.setAttribute('aria-roledescription', 'carousel');
        this.track.setAttribute('aria-label', this.dataset.carouselLabel || 'Featured campaigns');
      } else {
        ['tabindex', 'role', 'aria-roledescription', 'aria-label'].forEach(name => this.track.removeAttribute(name));
        this.track.scrollLeft = 0;
      }
      this.sync();
    }
    go(index, instant = false) {
      if (!this.mobile.matches || !this.cards[index]) return;
      const left = this.track.scrollLeft + this.cards[index].getBoundingClientRect().left - this.track.getBoundingClientRect().left;
      this.track.scrollTo({ left, behavior: instant || this.motion.matches ? 'instant' : 'smooth' });
    }
    sync() {
      if (!this.mobile.matches) return;
      const start = this.track.getBoundingClientRect().left;
      const distances = this.cards.map(card => Math.abs(card.getBoundingClientRect().left - start));
      const index = distances.indexOf(Math.min(...distances));
      this.current = index;
      const number = this.querySelector('[data-current]');
      const label = String(index + 1).padStart(2, '0');
      if (number.textContent !== label) number.textContent = label;
      this.indicators.forEach((indicator, position) => indicator.classList.toggle('is-active', position === index));
      this.querySelector('[data-step="-1"]').setAttribute('aria-disabled', String(index === 0));
      this.querySelector('[data-step="1"]').setAttribute('aria-disabled', String(index === this.cards.length - 1));
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      clearTimeout(this.timer);
      this.abort?.abort();
      this.observer?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
